import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllDormitorys = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllDormitory}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getDormitoryById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.Dormitory}?CompanyCode=${companyCode}&DormitoryCode=${code}`
  );
  return data;
};

const insertDormitory = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.Dormitory, input);
  return data;
};

const updateDormitory = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.Dormitory, input);
  return data;
};

const deleteDormitory = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.Dormitory}?CompanyCode=${companyCode}&DormitoryCode=${code}`
  );
  return data;
};

export const useGetDormitorysQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllDormitory],
    queryFn: () => getAllDormitorys(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetDormitoryByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.Dormitory],
    queryFn: () => getDormitoryById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertDormitoryMutation = () => {
  return useMutation({
    mutationFn: insertDormitory,
  });
};

export const useUpdateDormitoryMutation = () => {
  return useMutation({
    mutationFn: updateDormitory,
  });
};

export const useDeleteDormitoryMutation = () => {
  return useMutation({
    mutationFn: deleteDormitory,
  });
};
